import { render, staticRenderFns } from "./BattleSearch.vue?vue&type=template&id=733aefa7&"
import script from "./BattleSearch.vue?vue&type=script&lang=js&"
export * from "./BattleSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports